import { Flex, Typography } from "antd";

type YoutubeVideoProps = {
    src: string,
	width?: string,
	height?:string,
	caption?: string,
}

export const YoutubeVideoEmbed = (props: YoutubeVideoProps) => {
    return (
		<Flex vertical style={{ width: props.width || '960px' }}>
			<iframe
				height={props.height || '300px'}
				src={props.src}
				data-allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			/>
			<Typography.Paragraph>{props.caption}</Typography.Paragraph>
		</Flex>
	);
}